import { CalendarViewType, TimePanelStore } from './schema/TimePanelStore';
import { createStore } from 'satcheljs';
import { createNavigationStack } from 'owa-navigation-stack/lib/utils/createNavigationStack';

let getStore = createStore<TimePanelStore>('timePanelStore', <TimePanelStore>{
    sessionId: '',
    panelOpenTimestamp: null,
    calendarViewStack: createNavigationStack<CalendarViewType>('List'),
    selectedCalendarItemId: null,
    panelViewType: 'Calendar',
});

export default getStore;
